





























import { BCol, BContainer, BLink, BRow, VBTooltip } from "bootstrap-vue";
import WhatsAppTemplateForm from "@/views/modules/settings/whatsapp-templates/components/whatsAppTemplateForm.vue";
import { ref } from "@vue/composition-api";
import { TemplateCategory, TemplateInterface } from "@/interfaces/template.interface";
import axios from "@/libs/axios";
// @ts-ignore
import router from "@/router";
import ToastificationContent from "@/layouts/components/toastification/toastificationContent.vue";
// @ts-ignore
import i18n from "@/libs/i18n";
import useTemplatesList from "@/views/modules/settings/whatsapp-templates/useTemplatesList";
import { useToast } from "vue-toastification/composition";

export default {
    components: {
        BCol,
        BContainer,
        BLink,
        BRow,
        WhatsAppTemplateForm,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    setup() {
        const { getTranslatedError } = useTemplatesList();
        const toast = useToast();

        const templateToCreate = ref<TemplateInterface>({
            title: "",
            content: "",
            components: {},
            channels: [],
            mediaType: undefined,
            category: TemplateCategory.MARKETING,
            language: "en",
            wabaId: undefined,
            assetId: undefined,
            assetIsLocked: 0,
        });

        const isLoading = ref("");

        const submit = (template: TemplateInterface, submitForApproval = false) => {
            isLoading.value = submitForApproval ? "submit" : "save";

            axios
                .post("templates", template, { params: { "submit-for-approval": submitForApproval } })
                .then(() => {
                    toast(
                        {
                            component: ToastificationContent,
                            props: {
                                title: i18n.t("settings.templates.whatsapp.create.success"),
                                text: i18n.t("settings.templates.whatsapp.create.success"),
                                icon: "check",
                                variant: "success",
                            },
                        },
                        {
                            timeout: 10000,
                        }
                    );

                    router.push({ name: "settings-whatsapp-templates" });
                })
                .catch((error) => {
                    toast(
                        {
                            component: ToastificationContent,
                            props: {
                                title: i18n.t("settings.templates.whatsapp.create.failed"),
                                text: getTranslatedError(error.response?.data?.message),
                                icon: "times",
                                variant: "danger",
                            },
                        },
                        {
                            timeout: 10000,
                        }
                    );
                })
                .finally(() => {
                    isLoading.value = "";
                });
        };

        return {
            templateToCreate,
            submit,
            isLoading,
        };
    },
};
